export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-mail-send-line text-sm"></i>
            联系我们
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm mt-2">欢迎投稿、合作与咨询</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              <div className="text-center p-5 rounded-xl bg-background-100">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">投稿邮箱</h3>
                <p className="text-foreground-500 text-sm">tougao@51chigua.com</p>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-100">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-group-line text-xl"></i>
                </span>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">商务合作</h3>
                <p className="text-foreground-500 text-sm">hezuo@51chigua.com</p>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-100">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-customer-service-2-line text-xl"></i>
                </span>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">客服咨询</h3>
                <p className="text-foreground-500 text-sm">kefu@51chigua.com</p>
              </div>
            </div>

            <div className="mt-8 p-5 rounded-xl bg-accent-50/50 border border-accent-200/50 text-center">
              <p className="text-foreground-600 text-sm leading-relaxed">
                如果你有娱乐八卦线索、独家爆料或原创内容，欢迎随时联系我们。
                优质投稿将获得优先展示机会，共同打造更好的吃瓜社区。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}